import { filterOption as defaultFilterOption } from './utils';
export var defaultProps = {
    className: '',
    placeholder: '',
    placement: 'Bottom',
    prefix: '@',
    split: ' ',
    filterOption: defaultFilterOption,
    loading: false,
    rows: 1,
    onFocus: function () { },
    onBlur: function () { },
    onChange: function (value) { },
    onSearch: function (value, prefix) { },
    onSelect: function (value, option) { },
    children: '',
    style: {},
};
export var defaultOptionList = {};
